import { isFreeOpenPath } from '@/lib/free-access'
import { useSerpQuota } from '@/hooks/use-serp-quota'

export interface UseFreeAccessResult {
  /**
   * Sunucu kullanıcıyı "limited" (Free sınırlı erişim) sayıyor mu.
   * Sunucu bu modu YALNIZ Pro olmayan kullanıcıya uygular; yönetici kohortunda
   * Pro olmayan yönetici de limited'dır, bu yüzden `limited` doğruyken site
   * kullanıcıyı Free sayar (yönetici dahil). Yükleniyor/hata/kapalı: false (fail-open).
   */
  limited: boolean
  /** Durum henüz yüklenmedi. */
  loading: boolean
  /** Yol Free'ye kısmen açık mı (tek kaynak: `lib/free-access`). */
  isOpenPath: (path: string | null | undefined) => boolean
}

export function useFreeAccess(): UseFreeAccessResult {
  const { isLimited, isLoading } = useSerpQuota()
  return { limited: isLimited, loading: isLoading, isOpenPath: isFreeOpenPath }
}
